import * as yup from 'yup';

export const yupLedgerAccountSchema = yup.object().shape({
  number: yup.number().required(),
  name: yup.string().required(),
  accountType: yup.string().required(),
});
